import cookies from '@/lib/cookies';
export var MutationTypes;
(function (MutationTypes) {
    MutationTypes["CHANGE_LANGUAGE"] = "CHANGE_LANGUAGE";
    MutationTypes["CHANGE_USER_THEME"] = "CHANGE_USER_THEME";
    MutationTypes["CHANGE_NOVA_STATUS"] = "CHANGE_NOVA_STATUS";
    MutationTypes["UPDATE_FETCH_STATUS"] = "UPDATE_FETCH_STATUS";
    MutationTypes["CHANGE_WARNING_TRIGGERED"] = "CHANGE_WARNING_TRIGGERED";
    MutationTypes["CHANGE_USER_TEXT"] = "CHANGE_USER_TEXT";
    MutationTypes["CHANGE_RESPONSE_TEXT"] = "CHANGE_RESPONSE_TEXT";
})(MutationTypes || (MutationTypes = {}));
export const mutations = {
    [MutationTypes.CHANGE_LANGUAGE](state, newLanguage) {
        state.language = newLanguage;
        if (cookies.isKey('nova-use-cookies')) {
            cookies.set('nova-language', newLanguage);
        }
    },
    [MutationTypes.CHANGE_USER_THEME](state, newUserTheme) {
        state.userTheme = newUserTheme;
        if (cookies.isKey('nova-use-cookies')) {
            cookies.set('nova-theme', newUserTheme);
        }
    },
    [MutationTypes.CHANGE_NOVA_STATUS](state, newNovaStatus) {
        state.novaStatus = newNovaStatus;
    },
    [MutationTypes.UPDATE_FETCH_STATUS](state, newFetchStatus) {
        state.novaStatus = state.novaStatus !== 'sleeping'
            ? newFetchStatus
                ? 'loading'
                : state.warningTriggered
                    ? 'warning'
                    : 'active'
            : 'sleeping';
        state.fetchStatus = newFetchStatus;
    },
    [MutationTypes.CHANGE_WARNING_TRIGGERED](state, warningIsTriggered) {
        state.warningTriggered = warningIsTriggered;
    },
    [MutationTypes.CHANGE_USER_TEXT](state, newUserText) {
        state.userText = newUserText;
    },
    [MutationTypes.CHANGE_RESPONSE_TEXT](state, newResponseText) {
        state.responseText = newResponseText;
    }
};
